import { createSlice, createAsyncThunk, createEntityAdapter } from '@reduxjs/toolkit';
import axios from 'axios';
import globalConfig from '../../configs/globalConfigs';
import { MODEL_SOURCE } from '../../constants';
import { mapPathways } from '../../utils/entity-utils';

/* ----------------------------------------------------------------
      SLICE (ACTIONS/REDUCERS)
---------------------------------------------------------------- */

const pathwaysAdapter = createEntityAdapter();

const initialState = pathwaysAdapter.getInitialState({
  loading: false,
  error: null,
});

const pathwaysSlice = createSlice({
  name: 'pathways',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(getAllPathways.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllPathways.fulfilled, (state, action) => {
      state.loading = false;
      pathwaysAdapter.setAll(state, action.payload);
    });
    builder.addCase(getAllPathways.rejected, (state, action) => {
      state.loading = false;
      pathwaysAdapter.setAll(initialState);
      state.error = action.error.message;
    });
  },
});

export default pathwaysSlice.reducer;

/* ----------------------------------------------------------------
      MIDDLEWARE - API CALLS
---------------------------------------------------------------- */
export const getAllPathways = createAsyncThunk('pathways/fetchPathways', async ({ source, region }) => {
  const result = await axios.post(source === MODEL_SOURCE ? globalConfig.API_PATHWAYS_URL : globalConfig.API_OFFICIAL_PATHWAYS_URL, { region });
  return mapPathways(result.data, region);
});

/* ----------------------------------------------------------------
      SELECTORS
---------------------------------------------------------------- */
export const pathwaysSelector = pathwaysAdapter.getSelectors((state) => state.globalDomain.pathways);
